'use strict';

define('vb/private/events/eventMonitorOptions',[
  'vbc/private/monitorOptions',
], (MonitorOptions) => {
  /**
   * Represents a log monitor options for a VB component and variable events.
   * These options are used in custom VB performance measures and open trace spans, if enabled.
   *
   * @extends MonitorOptions
   */
  class EventMonitorOptions extends MonitorOptions {
    /**
     * Creates an instance of EventMonitorOptions.
     *
     * @param {String} eventType - The type of the event to monitor.
     * @param {String} eventName - The name of the event to monitor.
     * @param {Object} eventPayload - The payload of the event to monitor.
     * @param {Object} container - The container associated with the event.
     */
    constructor(eventType, eventName, eventPayload, container) {
      super(eventType, eventName);
      this.addStartFields(() => ({
        trigger: eventPayload, // Tracer will parse into trigger.* fields
        container,
        eventName,
      }));
      this.addEndFields(() => ({
        trigger: eventPayload, // Tracer will parse into trigger.* fields
        container,
        eventName,
      }));
    }
  }

  return EventMonitorOptions;
});

